module.exports = __webpack_public_path__ + "img/q12.d32c3960.png";